import atoms from "../../../../atoms";
import { useTable } from "../hook";
import { HandleCalculationProps, ProductData, TInventoryTable } from "../interface";
import { contactLensColumns, inventoryColumns } from "./inventoryTableColumn";

interface InventoryTableProps {
    productData: ProductData[];
    handleCalculation: (value: HandleCalculationProps) => void;
    handleRemoveProduct: (customIndex: number, item: ProductData) => void;
    FilterProduct: (value: ProductData[], type: boolean) => TInventoryTable[];
    isNewInvoice:boolean
}
const { CustomTable } = atoms;

export const InventoryTable: React.FC<InventoryTableProps> = ({
    productData,
    handleCalculation,
    handleRemoveProduct,
    FilterProduct,
    isNewInvoice
}) => {
    const {
        renderCostAmount,
        renderDiscountPercentage,
        renderDiscountAmount,
        renderQty,
        renderStatus,
        renderVerificationStatus,
        renderAction,
        getTotalRow,
    } = useTable();

    return (
        <div>
            {productData && FilterProduct(productData, false)?.length > 0 ? (
                <CustomTable
                    columns={inventoryColumns(isNewInvoice)}
                    className="inventory-product-border"
                    style={{ overFlow: "auto !import" }}
                    data={getTotalRow(FilterProduct(productData, false))?.map(
                        (item: ProductData) => {
                            return {
                                ...item,
                                costAmount: renderCostAmount({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),
                                product_qty: renderQty({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),
                                discount_percentage: renderDiscountPercentage({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),
                                discount_amount: renderDiscountAmount({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),

                                is_Active: renderStatus(item),
                                verificationStatus: renderVerificationStatus(item),
                                action: renderAction({ item, handleRemoveProduct }),
                            };
                        }
                    )}
                />
            ) : (
                ""
            )}

            {productData && FilterProduct(productData, true)?.length > 0 ? (
                <CustomTable
                    columns={contactLensColumns(isNewInvoice)}
                    className="inventory-product-border"
                    style={{ overFlow: "auto !import" }}
                    data={getTotalRow(FilterProduct(productData, true))?.map(
                        (item: ProductData) => {
                            return {
                                ...item,
                                costAmount: renderCostAmount({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),
                                product_qty: renderQty({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),
                                discount_percentage: renderDiscountPercentage({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),
                                discount_amount: renderDiscountAmount({
                                    item,
                                    handleCalculation: (type, value) =>
                                        handleCalculation({
                                            type,
                                            id:item.id,
                                            value,
                                        }),
                                }),

                                is_Active: renderStatus(item),
                                verificationStatus: renderVerificationStatus(item),
                                action: renderAction({ item, handleRemoveProduct }),
                            };
                        }
                    )}
                />
            ) : (
                ""
            )}
        </div>
    );
};
